<template>
    <el-form ref="formData" size="small" :rules="rules" status-icon :model="formData">
        <el-form-item prop="user_email" label="User Email">
            <el-input v-model="formData.user_email"></el-input>
        </el-form-item>
        <el-form-item prop="user_name" label="User Name">
            <el-input v-model="formData.user_name" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item align="left" style="margin: 30px 0" prop="user_type" label="User Type:">
            <el-select style="width: 150px" size="small" v-model="formData.user_type" default-first-option>
                <el-option :key=0 label="admin" :value=1></el-option>
                <el-option :key=1 label="craftie admin" :value=2></el-option>
                <el-option :key=2 label="content admin" :value=3></el-option>
                <el-option :key=3 label="device content admin" :value=4></el-option>
                <el-option :key=4 label="search admin" :value=5></el-option>
                <el-option :key=5 label="product admin" :value=6></el-option>
            </el-select>
        </el-form-item>
        <el-form-item align="right">
            <el-button @click="$emit('close',false)">Back</el-button>
            <el-button class="el-button--primary" @click="submit('formData')">Save</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    name: 'AdminUserAdd',
    props:{
        close: Function
    },
    data(){
        return{
            formData:{
                user_email:'',
                user_name:'',
                user_type:3
            },
            rules:{
                user_email:[
                    { required: true, message: 'please input user email!' },
                    { 
                        pattern: /^([a-zA-Z0-9]+[_|\+|\.|\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/, 
                        message: "please enter your vaild email!" 
                    }
                ],
                user_name:[
                    { required: true, message: 'please input user name!' },
                    { pattern: /^[\u4e00-\u9fff\w\.\+\-_]{1,32}$/, message: "format error!Up to 32 characters are allowed!" }
                ]
            }
        }
    },
    methods:{
        submit(formName){
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    this.$message.warning('Please check the input data!')
                    return
                }
                let loading=this.$util.loading()
                this.$api.rootV1.post('/web/user/addadmin', 
                    this.formData,
                    (res) => {
                        this.$alert( 'added successfully!','info', {
                            confirmButtonText: 'confirm',
                            type:'success',
                            callback: action => {
                                loading.close()
                                this.$emit("close",true)
                            }
                        })
                    }, 
                    (res) => {
                        this.$alert( `add failed!${res.errmsg}`,'info', {
                            confirmButtonText: 'confirm',
                            type:'error',
                            callback: action => {
                                loading.close()
                                this.$emit("close",false)
                            }
                        })
                    }
                )
            })
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/adminUser/AdminUserAdd.vue